import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import styles from "./styles.module.sass";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import { paths } from "render/routes/paths";
import { useVisitQuery } from "hooks/queries/useVisitQuery";
import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { useRoomQuery } from "hooks/queries/useRoomQuery";
import { useStartCheckInMutation } from "hooks/mutations/useStartCheckInMutation";
import { AppointmentCard } from "render/ui/presentation/AppointmentCard";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { CheckInParams } from "lib/types/checkInParameters";
import { generateVisitTypeLabel } from "lib/generateVisitTypeLabel";
import { useVisitHistoryQuery } from "hooks/queries/useVisitHistoryQuery";
import { APITypesV1 } from "@cur8/api-client";

export function SelectVisitConfirmView({
  goTo,
  onBack,
  patientId,
  visitId,
}: {
  goTo: (url: string) => void;
  onBack(): void;
} & CheckInParams) {
  const visitQuery = useVisitQuery({ patientId, visitId });
  const patientQuery = usePatientQuery({ patientId });
  const member = patientQuery.data;
  const visit = visitQuery.data;
  const roomQuery = useRoomQuery({ roomId: visit?.roomId });
  const room = roomQuery.data;

  const fullName = `${member?.name?.firstName} ${member?.name?.lastName}`;
  const time = `${visit?.startTime.toFormat(
    "HH:mm"
  )} - ${visit?.endTime.toFormat("HH:mm")}`;
  const roomName = room?.displayName;

  const { data: visitHistory } = useVisitHistoryQuery({ patientId });
  const visitTypeLabel =
    visit != null && visitHistory != null
      ? generateVisitTypeLabel({ visit, visitHistory })
      : undefined;

  const isBodyScan = visit?.medicalExams?.includes(
    APITypesV1.MedicalExam.NekoBodyScan
  );
  const url = isBodyScan
    ? paths.preferredName.url({ patientId, visitId })
    : paths.assignToRoom.url({ patientId, visitId });

  const startCheckInMutation = useStartCheckInMutation();

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <div className={styles.title}>
              <Typography variant="display-s">Confirm check-in</Typography>
              <Typography variant="body-m" color="subtle">
                Confirm that this is the correct member.
              </Typography>
            </div>

            <AppointmentCard
              topLeft={fullName}
              topRight={roomName}
              bottomLeft={visitTypeLabel}
              bottomRight={time}
            />
          </section>
        }
        buttons={
          <ActionsFooter
            left={
              <Button variant="secondary" onPress={onBack} fillContainer>
                Back
              </Button>
            }
            right={
              <Button
                onPress={() => {
                  startCheckInMutation.mutate(
                    { patientId, visitId },
                    { onSuccess: () => goTo(url) }
                  );
                }}
                fillContainer
                icon={<Icon24ArrowRight />}
              >
                Continue
              </Button>
            }
          />
        }
      />
    </PageFrameContent>
  );
}
